<template>
  <v-card class="dialog dialog-modal-cotacao">
    <v-card-title class="mb-4 primary">
      <h3 class="headline white--text">SOLICITAÇÃO DE COTAÇÃO</h3>
      <v-spacer></v-spacer>
      <v-btn icon flat class="ma-0" title="Fechar" @click.prevent="fecharDialog()">
        <v-icon color="white">close</v-icon>
      </v-btn>
    </v-card-title>
    <v-container>
      <v-layout row wrap>
        <v-flex
          xs4
          md2
        >
          <v-flex
            xs12
            md12
          >
            <v-btn :class="customDadosCorretorParceiro ? 'active' : ''" class="btn-side-tabsCustom" block @click="tabCorretorParceiroVisualizacao(1)">DADOS</v-btn>
          </v-flex>
          <v-flex
            xs12
            md12
          >
            <v-btn :class="customTratativaCorretorParceiro ? 'active' : ''" class="btn-side-tabsCustom" block @click="tabCorretorParceiroVisualizacao(2);" >TRATATIVAS</v-btn>
          </v-flex>
        </v-flex>
        <v-flex
          xs10
          md10
        >
          <div v-show="customDadosCorretorParceiro == true" >
            <v-card-text style="min-height: 340px" class="pt-0" flex>
              <v-card  style="background-color: transparent" flat>
                <v-card-text class="pt-0">
                  <v-form ref="formulario" grid-list-lg class="content">
                <v-layout row wrap>
                  <v-flex md6 xs12 class="pr-4">
                    <v-select
                      label="Status de Solicitação"
                      browser-autocomplete="off"
                      riquered
                      item-text="titulo"
                      disabled
                      item-value="id"
                      :items="statusCorretorReservaList"
                      v-model="corretor.idStatusCorretorReserva"
                    >
                    </v-select>
                  </v-flex>
                  <v-layout row wrap>
                    <v-flex md6 xs12>
                      <v-btn  color="secondary" :disabled="corretor.idApolice == null || corretor.idApolice == true" @click="abrirEdicaoQar">VISUALIZAR QAR</v-btn>
                    </v-flex>
                    <v-flex md6 xs12>
                      <v-btn  :disabled="(corretor.idStatusCorretorReserva != 3 && corretor.numeroApolice != 'null') && (corretor.idStatusCorretorReserva != 6) && (corretor.idStatusCorretorReserva != 10)" @click="enviarTelaEndosso" color="primary" >ENDOSSOS</v-btn>
                    </v-flex>
                  </v-layout>
                </v-layout>
                <h3 style="color: #696969">Dados do Segurado:</h3>
                <v-layout  row wrap>
                <v-flex md6 xs12 class="pr-4">
                    <v-text-field
                      label="Razão Social"
                      browser-autocomplete="off"
                      required
                      disabled
                      v-model="corretor.razaoSocial"
                    >
                    </v-text-field>
                  </v-flex>

                  <v-spacer></v-spacer>
                  <v-flex md6 xs12>
                    <v-text-field
                      label="CNPJ da Empresa"
                      browser-autocomplete="off"
                      riquered
                      :mask="'NN.NNN.NNN/NNNN-##'"
                      disabled
                      v-model="corretor.cnpj"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs12 sm12 md6 class="pr-4">
                    <v-select
                      label="Companhia de renovação"
                      browser-autocomplete="off"
                      riquered
                      item-text="titulo"
                      item-value="id"
                      disabled
                      :items="ciaRenovacaoList"
                      v-model="corretor.idCiaRenovacao"
                    >
                    </v-select>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex md6 xs12>
                    <v-menu
                      ref="menu"
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="textInicio"
                          label="Vencimento da apólice"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          required
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="corretor.dataVencimentoApolice"
                        no-title
                        scrollable
                        disabled
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                <v-layout>
                  <v-flex  md6 xs12 class="pr-4">
                    <v-radio-group
                    v-model="corretor.detentorApolice"
                    disabled class="my-0 pt-0">
                      <span >Corretor é detentor da apólice?</span>
                      <v-layout>
                        <v-flex
                          d-flex
                          align-center
                          v-for="item in simOuNao"
                          :key="item.titulo"
                          ><v-radio :label="item.titulo" :value="item.value">
                          </v-radio
                        ></v-flex>
                      </v-layout>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
                </v-layout>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-card-text>
          </div>
          <div style="min-height: 340px" v-show="customTratativaCorretorParceiro == true" >
            <ChatTratativa
              v-if="customTratativaCorretorParceiro"
              :idCorretorReserva="corretor.id"
              :idApolice="corretor.idApolice"
              @carregada="tratativaCarregada"
              @enviada="tratativaAtualizada"
            ></ChatTratativa>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
     <v-dialog persistent v-model="visualizarInfoApolice" max-width="1350px">
        <ModalInfoCotacao
          :dadosCotacaoReserva="corretor"
          @atualizar="visualizarInfoApolice = false"
          :clickVisualizar="eventoInfoSolicitacao"
          @voltar="visualizarInfoApolice = false"
        ></ModalInfoCotacao>
      </v-dialog>
    <v-dialog
      v-model="dialogArquivosCorretor"
      max-width="500"
      scrollable
    >
      <ModalArquivo @fechar="dialogArquivosCorretor = false" :arquivosListProp="arquivosList"></ModalArquivo>
    </v-dialog>
     <v-snackbar
      :timeout="3000"
      :color="snackbar.sucesso ? 'success' : 'error'"
      multi-line
      v-model="snackbar.visivel"
    >
      {{ snackbar.mensagem }}
      <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
    </v-snackbar>
  </v-card>
</template>
<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import ModalArquivo from "./ModalArquivo.vue";
import ModalInfoCotacao from "./ModalInfoCotacao.vue";
import ChatTratativa from "../tratativa/ChatTratativa.vue";

export default {
  name: "ModalCotacaoAnalista",
  data: () => ({
    dialogArquivosCorretor: false,
    corretor: {
      dataVencimentoApolice: null,
      cnpj: null,
      idCiaRenovacao: null,
      razaoSocial: null,
      descricao:null,
      detentorApolice: null,
      idStatusCorretorReserva: null,
      usuario: [],
    },
    tabs: null,
    solicitacaoConcluida: false,
    snack: null,
    snackText: null,
    snackColor: null,
    detentorApolice: false,
    statusAlterado: false,
    visualizarInfoApolice: false,
    arquivosList: [],
    eventoInfoSolicitacao: false,
    ciaRenovacaoList: [],
    customTratativaCorretorParceiro: false,
    customDadosCorretorParceiro: true,
    snackbar: {
      visivel: false,
      sucesso: false,
      mensagem: ""
    },
    menu1: false,
    statusCorretorReservaList: [],
    regras: {
      notNull: [
        (v) =>
          !!(v instanceof Array ? v.length : v !== null) ||
          "Você não pode deixar este campo em branco",
      ],
    },
    simOuNao: [
      {
        value: true,
        titulo: "Sim",
      },
      {
        value: false,
        titulo: "Não",
      },
    ],
    dateInicio: null
  }),
  components: {
    ModalArquivo,
    ModalInfoCotacao,
    ChatTratativa
},
  props: {
    objetoCorretor: {
      type: Object
    },
    idStatusCorretor: {
      type: Number
    },
    abrirEmTratativas: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    objetoCorretor: {
      immediate: true,
      handler() {
        this.corretor = this.objetoCorretor;
        this.buscarArquivos();
      }
    },

  },
  mounted() {
    this.buscarListaStatus()
    this.buscarListaCia();
    if (this.abrirEmTratativas) {
      this.tabCorretorParceiroVisualizacao(2);
    }
  },
  computed: {
    textInicio() {
      if(this.corretor.dataVencimentoApolice){
        return new Date(this.corretor.dataVencimentoApolice).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "long",
          day: "numeric"
        });
      }
    },

  },

  methods: {

    abrirEdicaoQar() {
      this.eventoInfoSolicitacao = !this.eventoInfoSolicitacao;
      this.visualizarInfoApolice = true;
    },
    tratativaCarregada(tratativa) {
      this.$emit("tratativaCarregada", tratativa);
    },
    tratativaAtualizada(tratativa) {
      this.$emit("tratativaAtualizada", tratativa);
    },
    tabCorretorParceiroVisualizacao(id) {
      if( id == 1 ) {
        this.customTratativaCorretorParceiro = false;
        this.customDadosCorretorParceiro = true;
      }
      if( id == 2 ) {
        this.customDadosCorretorParceiro = false;
        this.customTratativaCorretorParceiro = true;
      }
    },
    enviarTelaEndosso() {
      this.$router.push("/corretor/endossos?id=" + this.corretor.idApolice + "&idStatusCorretorReserva=" + this.corretor.idStatusCorretorReserva);
    },
    buscarListaStatus () {
      axios.get(`${process.env.URL_CORRETORMS}/v1/statusCorretorReserva`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.statusCorretorReservaList =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          console.error(err);
        });
    },
    buscarListaCia () {
      axios.get(`${process.env.URL_CORRETORMS}/v1/ciaRenovacao`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.ciaRenovacaoList =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          console.error(err);
        });
    },
    buscarArquivos() {
    if (!this.corretor || !this.corretor.id) {
      this.arquivosList = [];
      return;
    }
    this.$store.commit("startLoading");
      axios
        .get(
          `${process.env.URL_CORRETORMS}/v1/buscarArquivosCorretorReserva/${this.corretor.id}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.arquivosList = response.data;
          this.$store.commit("endLoading");
        })
        .catch(err => {
          this.$store.commit("endLoading");
        });
    },


    fecharDialog() {
      this.customTratativaCorretorParceiro = false;
      this.customDadosCorretorParceiro = true;
      this.$emit("fecharDialog");
    },
    onDateChange: function() {
      this.dateInicio = this.objeto.dataVencimentoApolice
    },

  }
};
</script>

<style>
  .btn-side-tabsCustom {
    box-shadow: none!important;
    background-color: transparent!important;
    color: #00456e!important;
    border: 0;
    margin: 0;
  }
  .dialog-modal-cotacao .theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
    opacity: 0.4;
    background-color: #555!important;
  }
  .btn-side-tabsCustom.active {
    border-left: 4px solid #00466E;
  }
  .btn-side-tabsCustom .v-btn__content {
    justify-content: left!important;
  }

  .btn-anexos-arquivos {
    border: 0!important;
    background-color: transparent!important;
    box-shadow: none!important;
  }
  .btn-anexos-arquivos:hover  {
    background-color: transparent!important;

   text-decoration-color: #00456e;
  }
  .btn-anexos-arquivos:hover .v-icon {
    color: #00456e;
  }
  .btn-anexos-arquivos:hover p  {
    color: #00456e;
    text-decoration: underline;
    text-decoration-color: #00456e;
  }


</style>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/ModalCotacaoAnalista.vue